import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DoDisturbOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"do_disturb_on"}/>
}
